import { defineMessages } from 'react-intl';

export default defineMessages({
  returnsAndExchangesSettingsTitle: {
    description: 'Header for returns and exchanges settings section',
    defaultMessage: 'Returns & Exchanges',
    id: 'wLTRvm',
  },
  returnsSettingsTitle: {
    description: 'Header for returns settings section',
    defaultMessage: 'Returns',
    id: 'I/ajA/',
  },
  returnSettingsDescription: {
    description: 'Description for returns settings section',
    defaultMessage:
      'Configure and customize settings for creating and managing returns in your account. These settings only apply to the selected store.',
    id: 'VHcqMW',
  },
  returnsAndExchangesSettingsDescription: {
    description: 'Description for returns and exchange settings section',
    defaultMessage:
      'Configure and customize settings for creating and managing returns and exchanges in your account. These settings only apply to the selected store.',
    id: 'GLfKRD',
  },
});
